<app-page [simpleTopBar]="globalVars.isMobile()" [title]="title">
  <nft-post (postLoaded)="title = $event"></nft-post>
</app-page>
